interface StepIndicatorProps {
	steps: string[];
	currentStep: number;
}

function getStepClass(index: number, currentStep: number): string {
	const base = "step-indicator__step";

	if (index < currentStep) {
		return `${base} ${base}--completed`;
	}
	if (index === currentStep) {
		return `${base} ${base}--active`;
	}
	return base;
}

export function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
	return (
		<div className="step-indicator">
			{steps.map((label, index) => (
				<div key={label} className={getStepClass(index, currentStep)}>
					<div className="step-indicator__circle">{index < currentStep ? "✓" : index + 1}</div>
					<span className="step-indicator__label">{label}</span>
					{index < steps.length - 1 && <div className="step-indicator__connector" />}
				</div>
			))}
		</div>
	);
}
